import { render, staticRenderFns } from "./StandardItemName.vue?vue&type=template&id=117ade53"
import script from "./StandardItemName.vue?vue&type=script&lang=js"
export * from "./StandardItemName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports